import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class AcceptDocButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
        const { showNotification, record, refreshView } = this.props;

        this.setState({
          executing: true
        });
    
        const {
          id,
          warehouseFrom = null,
          warehouseTo = null,
        } = record;
        let data = {
          docId: id
        }
        let url = '/admin/doc/func/acceptance';
        if (warehouseFrom && warehouseTo) {
          url = '/admin/doc/func/warehouse/accept';
        }

        let response = null;
        try {
          response = await request({
            apiService: 'shoes',
            path: url,
            urlParams: data,
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.acceptDoc.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.acceptDoc.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        return (
            <Button label={`resources.${resourceConfig.name}.acceptDoc.action`} disabled={this.state.executing} onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { 
  showNotification, 
  refreshView: refreshViewAction 
})(AcceptDocButton);